export default "__VITE_ASSET__Dqe93KSe__"